import { PublicBooking, SlotsResponse } from '../types'

export function fetchPublicSlots(userSlug: string, eventSlug: string, params: { from: string, to: string, timezone: string, duration: number }, previewToken?: string | null): Promise<SlotsResponse> {
  const query = new URLSearchParams({ ...params, duration: String(params.duration), ...(previewToken ? { preview: previewToken } : {}) }).toString()
  return fetch(`/${userSlug}/${eventSlug}/slots?${query}`, { headers: { Accept: 'application/json' } }).then(res => {
    if (!res.ok) throw new Error(`slots ${res.status}`)
    return res.json()
  })
}

export interface CreateBookingBody {
  start: string
  duration: number
  location: string | null
  location_value: string
  name: string
  email: string
  timezone: string
  notes: string
  guests: string[]
}

export type CreateBookingResult =
  | { ok: true, booking: PublicBooking }
  | { ok: false, status: number, error: string, details?: Record<string, string> }

export async function createPublicBooking(userSlug: string, eventSlug: string, body: CreateBookingBody): Promise<CreateBookingResult> {
  try {
    const res = await fetch(`/${userSlug}/${eventSlug}/bookings`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    const json = await res.json().catch(() => ({}))
    if (res.ok) return { ok: true, booking: json.booking }
    return { ok: false, status: res.status, error: json.error || 'unknown', details: json.details }
  } catch (e) {
    return { ok: false, status: 0, error: 'network' }
  }
}
